import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { AuthGoogleProvider } from '@/app/providers/AuthGoogleProvider';
import { RealtimeProvider } from '@/shared/lib/realtime';
import { AppErrorBoundary } from '@/shared/ui/feedback/AppErrorBoundary';
import { appRoutes } from '@/routes';

const router = createBrowserRouter(appRoutes);

const App = () => (
  <AuthGoogleProvider>
    <QueryProvider>
      <RealtimeProvider>
        <AppErrorBoundary>
          <RouterProvider router={router} />
        </AppErrorBoundary>
        <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      </RealtimeProvider>
    </QueryProvider>
  </AuthGoogleProvider>
);

export default App;
